/*
 *
 * ----------------------------------------------- */

$(window).on("load resize", function () {
  var $sectionIntroduction = $(".section-introduction");
  var scrollPos = 0;

  if ($sectionIntroduction) {
    var windowHeight = $(window).height();
    $sectionIntroduction.css("height", 2 * windowHeight + 500);

    var $textRevealContainer = $(".text-reveal-container");
    var $textReveal = $(".text-reveal");
    var distFromTop = $textRevealContainer.offset().top;
    var scrollDistance = distFromTop + windowHeight;

    $(document).scroll(function () {
      scrollPos = $(this).scrollTop();

      if (scrollPos >= distFromTop && scrollPos <= scrollDistance) {
        $textRevealContainer.addClass("is-sticky");
      } else {
        $textRevealContainer.removeClass("is-sticky");
      }

      if ($textRevealContainer.hasClass("is-sticky")) {
        if (scrollPos > distFromTop + 100) {
          $textReveal.eq(0).addClass("active");
        } else {
          $textReveal.eq(0).removeClass("active");
        }

        if (scrollPos > distFromTop + 200) {
          $textReveal.eq(1).addClass("active");
        } else {
          $textReveal.eq(1).removeClass("active");
        }

        if (scrollPos > distFromTop + 300) {
          $textReveal.eq(2).addClass("active");
        } else {
          $textReveal.eq(2).removeClass("active");
        }

        if (scrollPos > distFromTop + 400) {
          $textReveal.eq(3).addClass("active");
        } else {
          $textReveal.eq(3).removeClass("active");
        }
      } else {
        $textReveal.removeClass("active");
      }
    });
  }
});
